import { StateListType } from './types';

export const stateList: StateListType[] = [{
  id: 'AB',
  country: 'CA',
  label: 'Alberta',
}, {
  id: 'AK',
  country: 'US',
  label: 'Alaska',
}, {
  id: 'AL',
  country: 'US',
  label: 'Alabama',
}, {
  id: 'AR',
  country: 'US',
  label: 'Arkansas',
}, {
  id: 'AZ',
  country: 'US',
  label: 'Arizona',
}, {
  id: 'BC',
  country: 'CA',
  label: 'British Columbia',
}, {
  id: 'CA',
  country: 'US',
  label: 'California',
}, {
  id: 'CO',
  country: 'US',
  label: 'Colorado',
}, {
  id: 'CT',
  country: 'US',
  label: 'Connecticut',
}, {
  id: 'DC',
  country: 'US',
  label: 'District of Columbia',
}, {
  id: 'DE',
  country: 'US',
  label: 'Delaware',
}, {
  id: 'FL',
  country: 'US',
  label: 'Florida',
}, {
  id: 'GA',
  country: 'US',
  label: 'Georgia',
}, {
  id: 'GU',
  country: 'US',
  label: 'Guam',
}, {
  id: 'HI',
  country: 'US',
  label: 'Hawaii',
}, {
  id: 'IA',
  country: 'US',
  label: 'Iowa',
}, {
  id: 'ID',
  country: 'US',
  label: 'Idaho',
}, {
  id: 'IL',
  country: 'US',
  label: 'Illinois',
}, {
  id: 'IN',
  country: 'US',
  label: 'Indiana',
}, {
  id: 'KS',
  country: 'US',
  label: 'Kansas',
}, {
  id: 'KY',
  country: 'US',
  label: 'Kentucky',
}, {
  id: 'LA',
  country: 'US',
  label: 'Louisiana',
}, {
  id: 'MA',
  country: 'US',
  label: 'Massachusetts',
}, {
  id: 'MB',
  country: 'CA',
  label: 'Manitoba',
}, {
  id: 'MD',
  country: 'US',
  label: 'Maryland',
}, {
  id: 'ME',
  country: 'US',
  label: 'Maine',
}, {
  id: 'MI',
  country: 'US',
  label: 'Michigan',
}, {
  id: 'MN',
  country: 'US',
  label: 'Minnesota',
}, {
  id: 'MO',
  country: 'US',
  label: 'Missouri',
}, {
  id: 'MS',
  country: 'US',
  label: 'Mississippi',
}, {
  id: 'MT',
  country: 'US',
  label: 'Montana',
}, {
  id: 'NB',
  country: 'CA',
  label: 'New Brunswick',
}, {
  id: 'NC',
  country: 'US',
  label: 'North Carolina',
}, {
  id: 'ND',
  country: 'US',
  label: 'North Dakota',
}, {
  id: 'NE',
  country: 'US',
  label: 'Nebraska',
}, {
  id: 'NL',
  country: 'CA',
  label: 'Newfoundland and Labrador',
}, {
  id: 'NH',
  country: 'US',
  label: 'New Hampshire',
}, {
  id: 'NJ',
  country: 'US',
  label: 'New Jersey',
}, {
  id: 'NM',
  country: 'US',
  label: 'New Mexico',
}, {
  id: 'NS',
  country: 'CA',
  label: 'Nova Scotia',
}, {
  id: 'NT',
  country: 'CA',
  label: 'Northwest Territories',
}, {
  id: 'NU',
  country: 'CA',
  label: 'Nunavut',
}, {
  id: 'NV',
  country: 'US',
  label: 'Nevada',
}, {
  id: 'NY',
  country: 'US',
  label: 'New York',
}, {
  id: 'OH',
  country: 'US',
  label: 'Ohio',
}, {
  id: 'OK',
  country: 'US',
  label: 'Oklahoma',
}, {
  id: 'ON',
  country: 'CA',
  label: 'Ontario',
}, {
  id: 'OR',
  country: 'US',
  label: 'Oregon',
}, {
  id: 'PA',
  country: 'US',
  label: 'Pennsylvania',
}, {
  id: 'PE',
  country: 'CA',
  label: 'Prince Edward Island',
}, {
  id: 'QC',
  country: 'CA',
  label: 'Quebec',
}, {
  id: 'RI',
  country: 'US',
  label: 'Rhode Island',
}, {
  id: 'SC',
  country: 'US',
  label: 'South Carolina',
}, {
  id: 'SD',
  country: 'US',
  label: 'South Dakota',
}, {
  id: 'SK',
  country: 'CA',
  label: 'Saskatchewan',
}, {
  id: 'TN',
  country: 'US',
  label: 'Tennessee',
}, {
  id: 'TX',
  country: 'US',
  label: 'Texas',
}, {
  id: 'UT',
  country: 'US',
  label: 'Utah',
}, {
  id: 'VA',
  country: 'US',
  label: 'Virginia',
}, {
  id: 'VI',
  country: 'US',
  label: 'Virgin Islands',
}, {
  id: 'VT',
  country: 'US',
  label: 'Vermont',
}, {
  id: 'WA',
  country: 'US',
  label: 'Washington',
}, {
  id: 'WI',
  country: 'US',
  label: 'Wisconsin',
}, {
  id: 'WV',
  country: 'US',
  label: 'West Virginia',
}, {
  id: 'WY',
  country: 'US',
  label: 'Wyoming',
}, {
  id: 'YT',
  country: 'CA',
  label: 'Yukon',
}];
